import { Heading, Stack, Text, HStack, Skeleton, Box } from '@chakra-ui/react'
import React from 'react'

import SocialLinks from './SocialLinks'
import { responsive } from '../contexts/responsive'
// import NextAvatar from '../NextAvatar'
// import Provider, { getTheme } from '../../contexts/chakra-ui/Provider'
import usePortalyLink from '../hooks/usePortalyLink'

import QrCodeModal from '../components/QrCodeModal'
import RatioImage from './RatioImage'

const HeaderSection = ({
  theme,
  fontFamily,
  avatar,
  name,
  description,
  social,
  headerLayout = 'center',
  isPreview,
  isEditing,
  editorRef,
  slug,
  showQrCode,
}) => {
  const link = usePortalyLink(slug)
  const alignItems = headerLayout === 'center' ? 'center' : 'flex-start'
  const textAlign = headerLayout === 'center' ? 'center' : 'left'
  const child = (
    <Stack
      bg="white"
      width="100%"
      p="4"
      pt="6"
      rounded="md"
      spacing={headerLayout === 'center' ? 4 : responsive(4, 8)}
      alignItems={alignItems}
      direction={headerLayout === 'center' ? 'column' : 'row'}
      as="section"
      boxShadow="sm"
      pos="relative"
    >
      <RatioImage
        width="6em"
        src={avatar}
        alt={name}
        ratio={1}
        rounded="full"
        overflow="hidden"
      />
      <Stack flex="1" alignItems={alignItems} w="full">
        {typeof name === 'undefined' ? <Skeleton w="full" h="7" /> : <Heading as="h1" fontSize="lg">{name}</Heading>}
        {typeof name === 'undefined' ? <Skeleton w="full" h="5" /> : <Text px="4" lineHeight="tall" textAlign={textAlign} whiteSpace="pre-wrap">{description}</Text>}
        {typeof social === 'undefined' ? (
          <HStack spacing={4}>{Array.from(new Array(3), (_, i) => <Skeleton key={i} w="8" h="8" />)}</HStack>
        ) : <SocialLinks {...social} isEditing={isEditing} />}
      </Stack>
      {isEditing && <div ref={editorRef} />}
      {!isEditing && showQrCode !== false && (
        <Box pos="absolute" top="0" right="4">
          <QrCodeModal trackerName="qrcode" size="sm" colorScheme="primary" link={link} name={name} />
        </Box>
      )}
    </Stack>
  )
  // return isPreview ? (
  //   <Provider override={getTheme({ theme, fontFamily })}>
  //     {child}
  //   </Provider>
  // ) : child
  return child
}

export default HeaderSection
